import { Injectable } from '@angular/core';
import { TextEditorHistoryService } from '@fi-shared/fi-text-editor/fi-text-editor-helper-services/text-editor-history.service';
import { AppTextService } from '@fi-shared/app-text';
import { ITextPanelButton } from '@fi-shared/fi-text-panel/simple-text-panel/text-panel-base';
import { FiContenteditableService } from '@fi-shared/fi-contenteditable/fi-contenteditable.service';
import { findClosest } from '@fi-shared/utils';

@Injectable()
export class AdvancedTextPanelListsService {
    constructor(
        private appTextService: AppTextService,
        private textEditorHistoryService: TextEditorHistoryService,
        private contenteditableService: FiContenteditableService,
    ) {}

    getButtons(): ITextPanelButton[] {
        return [
            {
                title: this.appTextService.get('text_editor.bullet_list'),
                class: 'fas fa-list-ul',
                btnClass: 'mobile-basic BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    document.execCommand('insertUnorderedList', false, null);
                },
                selected: () => !!findClosest(this.contenteditableService.getRangeStartElement(), 'ul', '.text-editor'),
            },
            {
                title: this.appTextService.get('text_editor.numbered_list'),
                class: 'fas fa-list-ol',
                btnClass: 'mobile-basic BrandedColorHover panel-icon-button',
                callback: () => {
                    this.textEditorHistoryService.saveState();
                    document.execCommand('insertOrderedList', false, null);
                },
                selected: () => !!findClosest(this.contenteditableService.getRangeStartElement(), 'ol', '.text-editor'),
            },
        ];
    }
}
